<p-toast
  preventOpenDuplicates="true"
  [life]="8000"
  [breakpoints]="{ '640px': { width: 'calc(100% - 2rem)', right: '1rem', left: '1rem' } }"
/>
<div class="w-svw h-svh overflow-y-auto overflow-x-hidden bg-gray-100 m-0">
  <router-outlet></router-outlet>
</div>
